/** Stock and restock reads that can change after a Send commits. */
export function restockSendInvalidatesQuery(parts: unknown): boolean {
  if (!Array.isArray(parts)) return false;
  return (
    (parts[0] === 'restocks' &&
      ['list', 'get', 'ownVan', 'previewSend', 'reorderPlan'].includes(
        String(parts[1]),
      )) ||
    (parts[0] === 'inventory' &&
      ['onHand', 'lowStock', 'ledger', 'negatives'].includes(String(parts[1])))
  );
}

/** Confirmed office planning actions affect incoming coverage as well as physical stock. */
export function reorderWriteInvalidatesQuery(parts: unknown): boolean {
  return (
    restockSendInvalidatesQuery(parts) ||
    (Array.isArray(parts) && ['purchasing', 'purchaseOrders'].includes(String(parts[0])))
  );
}
